import { appSettings } from '../appSettings';

export const getBaseURL = (): string => {
  /*
      ********************************************************************************
          window.location.protocol ==> Will give you whether it is http or https
          window.location.hostname ==> Will give you the domain name
      ********************************************************************************
      */
  let uri = `${window.location.protocol}//${window.location.hostname}`;

  /*
      ********************************************************************************
          If the uri contains localhost as domain then add port no.
      ********************************************************************************
      */
  if (uri.includes('localhost')) {
    uri = `${uri}:${window.location.port}`;
  }
  return uri;
};

export const onSignIn = () => {
  // Get the current URL
  const currentUrl = window.location.href;

  // Remove everything from and after '/Callback'
  const baseUrl = currentUrl.split('/Callback')[0];
  // Replace the current state without redirecting
  window.history.replaceState({}, document.title, baseUrl);
};

export const onSignOut = (): void => {
  window.location.replace(appSettings.OIDC_END_SESSION_ENDPOINT as string);
};